import {Pipe} from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe {
  transform(value: string, limitStr: string) : string {
    if(!value)
      return value;
    let limit = parseInt(limitStr);
    let trail = '...';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/truncate.pipe.ts